import { takeLatest, call } from 'redux-saga/effects';
import genericApiSaga from '../genericApiSaga';
import {
  actionCreators,
  types,
} from '../../redux/loyaltyProgram/loyaltyProgram.meta';
import { getMemberId } from './loyaltyProgram.gateway';

const withFormData = (formData, actionCreator) => payload =>
  actionCreator({ ...payload, ...formData });

export function* requestSearch({ payload }) {
  const { formName, givenName, familyName, email } = payload;
  const requestSearchCompleted = withFormData(
    { formName, givenName, familyName },
    actionCreators.requestSearchCompleted
  );
  const requestSearchFailed = withFormData(
    { formName, givenName, familyName },
    actionCreators.requestSearchFailed
  );

  yield call(genericApiSaga, {
    completed: requestSearchCompleted,
    failed: requestSearchFailed,
    gatewayCall: getMemberId(email, givenName, familyName),
  });
}

export default function* createLoyaltyProgramSaga() {
  yield takeLatest(types.REQUEST_SEARCH_MEMBER_ID, requestSearch);
}
